<template>
  <div
    v-if="shouldShow"
    :class="{ mastery: mastery }"
    class="apple-component-container icon-circle-wrapper"
    @click="authenticate"
  >
    <icon
      v-if="mastery"
      name="apple-icon"
    ></icon>
  </div>
</template>

<script>
import Authentication from '@/mixins/authentication';
import Icon from '@components/singletons/icon';

export default {
  components: { Icon },
  mixins: [Authentication],
  props: {
    createAccount: {
      type: Boolean,
      default: false,
    },
    mastery: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    shouldShow() {
      if (!window.AppleID) {
        return false;
      }
      return this.$store.getters['app/appleLoginEnabled'];
    },
  },
  mounted() {
    if (!window.AppleID) {
      return;
    }
    const clientId = 'com.hltcorp.integrationtest.applelogin';
    const scope = 'name email';
    const redirectURI = document.location.origin;
    const state = 'sign-in';
    const usePopup = true;
    window.AppleID.auth.init({
      clientId,
      scope,
      redirectURI,
      state,
      usePopup,
    });
    document.addEventListener('AppleIDSignInOnSuccess', this.callOnSuccess);
    document.addEventListener('AppleIDSignInOnFailure', this.callOnFailure);
  },
  beforeUnmount () {
    document.removeEventListener('AppleIDSignInOnSuccess', this.callOnSuccess);
    document.removeEventListener('AppleIDSignInOnFailure', this.callOnFailure);
  },
  methods: {
    authenticate() {
      if (window.AppleID) {
        window.AppleID.auth.signIn();
      }
    },
    callOnFailure(event) {
      console.log('fail');
      console.log(event);
    },
    callOnSuccess(data) {
      console.log('success');
      console.log(data);
      const appleUserData = this.getAppleDataFromToken(data.detail.authorization.id_token);
      console.log(appleUserData);

      const appleJwk = data.detail.authorization.id_token;
      const trackingParams = this.collectTrackingParams();
      this.$notify({
        group: 'notifications',
        text: 'Authenticating',
        type: 'success',
      });

      this.$store.dispatch('session/signIn', [{ appleJwk, ...trackingParams }]).then(response => {
        this.$notify({
          group: 'notifications',
          text: 'You are now logged in',
          type: 'success',
        });
        this.redirectAfterSignIn();
      }).catch(e => {
        console.log('error');
        console.log(e);
        this.errorNotification();
      });


    },
    errorNotification(message) {
      this.$notify({
        group: 'notifications',
        text: message || 'Apple Authentication Failed',
        type: 'error',
      });
    },
    getAppleDataFromToken(token){
      var base64Url = token.split('.')[1];
      var base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
      var jsonPayload = decodeURIComponent(atob(base64).split('').map(function(c) {
        return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
      }).join(''));
      return JSON.parse(jsonPayload);
    },
  },
};
</script>
<style lang='scss' scoped>
  .apple-component-container {
    background-color: #000000;
    box-sizing: border-box;
    color: white;
    cursor: pointer;

    &.mastery {
      border-radius: var(--radius-full);
      display: grid;
      place-content: center;
      height: 44px;
      width: 44px;
    }
  }
</style>
